import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess304002Status: 'idle',
    startProcess304002Error: undefined as any,
    loadUserParamsProcess304002Status: 'idle',
    loadUserParamsProcess304002Error: undefined as any,

    process304002List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess304002 = createAsyncThunk('process304002Slice/startProcess304002', async ({ process304002 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess304002/`,
        prepareData(process304002),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess304002Status } = getState().process304002Slice
        return startProcess304002Status !== 'pending'
    }
})

export const loadUserParamsProcess304002 = createAsyncThunk('process304002Slice/loadUserParamsProcess304002', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess304002/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess304002Status } = getState().process304002Slice
        return loadUserParamsProcess304002Status !== 'pending'
    }
})

const Process304002Slice = createSlice({
    name: 'process304002Slice',
    initialState,
    reducers: {
        resetstartProcess304002: (state) => {
            state.job = undefined
            state.startProcess304002Error = undefined
        },
        resetstartProcess304002Error: (state) => {
            state.startProcess304002Error = undefined
        },
        resetloadUserParamsProcess304002: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess304002Error = undefined
        },
        resetloadUserParamsProcess304002Error: (state) => {
            state.loadUserParamsProcess304002Error = undefined
        },
        removeFromProcess304002ListById: (state, action) => {
            state.process304002List = state.process304002List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess304002ListByIds: (state, action) => {
            state.process304002List = state.process304002List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process304002List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess304002Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process304002List = []
            state.startProcess304002Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess304002.pending, (state) => {
            state.startProcess304002Status = 'pending'
            state.startProcess304002Error = undefined
        })
        builder.addCase(startProcess304002.fulfilled, (state, action) => {
            state.startProcess304002Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess304002.rejected, (state, action) => {
            state.startProcess304002Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess304002Error = action.error.message
            } else {
                state.startProcess304002Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess304002.pending, (state) => {
            state.loadUserParamsProcess304002Status = 'pending'
            state.loadUserParamsProcess304002Error = undefined
        })
        builder.addCase(loadUserParamsProcess304002.fulfilled, (state, action) => {
            state.loadUserParamsProcess304002Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess304002.rejected, (state, action) => {
            state.loadUserParamsProcess304002Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess304002Error = action.error.message
            } else {
                state.loadUserParamsProcess304002Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess304002,
    resetstartProcess304002Error,
    resetloadUserParamsProcess304002,
    resetloadUserParamsProcess304002Error,
    removeFromProcess304002ListById,
    removeFromProcess304002ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process304002Slice.actions
export default Process304002Slice.reducer
